import React from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { useLanguage, languages } from '../context/LanguageContext';

export default function LanguageSelector({ className = '' }) {
  const { currentLanguage, changeLanguage } = useLanguage();
  const current = languages[currentLanguage];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button 
          className={`flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-orange-600 transition-colors ${className}`}
          data-testid="language-selector-trigger"
        >
          <Globe className="w-4 h-4" />
          <span className="hidden sm:inline">{current.flag}</span>
          <span className="hidden md:inline">{current.name}</span>
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {Object.values(languages).map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`cursor-pointer flex items-center gap-2 ${currentLanguage === lang.code ? 'bg-orange-50 text-orange-600' : 'hover:bg-orange-50'}`}
            data-testid={`language-option-${lang.code}`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span>{lang.name}</span>
            {currentLanguage === lang.code && (
              <span className="ml-auto text-orange-600">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
